"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.EventKey = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _eventMap;
var EventType = /*#__PURE__*/function (EventType) {
  EventType["CLICK"] = "click";
  EventType["IMPRESSION"] = "impression";
  return EventType;
}(EventType || {});
var EventKey = exports.EventKey = /*#__PURE__*/function (EventKey) {
  EventKey["CALENDLY_DATETIME_CLICK"] = "calendlyDateTimeClick";
  EventKey["CALENDLY_ERROR_MODAL_IMPRESSION"] = "calendlyErrorModalImpression";
  EventKey["CALENDLY_MODAL_IMPRESSION"] = "calendlyModalImpression";
  EventKey["CALENDLY_SCHEDULE_CLICK"] = "calendlyScheduleClick";
  EventKey["CAROUSEL_ARROW_CLICK"] = "carouselArrowClick";
  EventKey["CAROUSEL_CARD_CLICK"] = "carouselCardClick";
  EventKey["CAROUSEL_IMAGE_ENLARGE_CLICK"] = "carouselImageEnlargeClick";
  EventKey["CAROUSEL_SERVICE_IMPRESSION"] = "carouselServiceImpression";
  EventKey["EXPANDED_IMAGE_VIEW_CLOSE_CLICK"] = "expandedImageViewCloseClick";
  EventKey["EXPANDED_IMAGE_VIEW_IMPRESSION"] = "expandedImageViewImpression";
  EventKey["LOADER_ERROR_MODAL_CLOSE_CLICK"] = "loaderErrorModalCloseClick";
  EventKey["LOADER_ERROR_MODAL_IMPRESSION"] = "loaderErrorModalImpression";
  EventKey["LOADER_ERROR_MODAL_REFRESH_CLICK"] = "loaderErrorModalRefreshClick";
  EventKey["LOADER_LOADING_MODAL_IMPRESSION"] = "loaderLoadingModalImpression";
  EventKey["LOAD_MODAL_IMPRESSION"] = "loadModalImpression";
  EventKey["LOAD_EMBED_IMPRESSION"] = "loadEmbedImpression";
  EventKey["LEAD_GEN_MODAL_CLOSE_CLICK"] = "leadGenModalCloseClick";
  EventKey["FORM_SUBMIT_CLICK"] = "formSubmitClick";
  EventKey["PRODUCT_INTENT_DROPDOWN_CHANGE_CLICK"] = "productIntentDropdownChangeClick";
  EventKey["PRODUCT_INTENT_DROPDOWN_IMPRESSION"] = "productIntentDropdownImpression";
  EventKey["SCHEDULE_BUTTON_CLICK"] = "scheduleButtonClick";
  EventKey["SCHEDULE_BUTTON_IMPRESSION"] = "scheduleButtonImpression";
  EventKey["SMS_CHECKBOX_IMPRESSION"] = "smsCheckboxImpression";
  EventKey["PHOTO_VIDEO_TOGGLE_IMPRESSION"] = "photoVideoToggleImpression";
  EventKey["PHOTO_VIDEO_TOGGLE_CLICK"] = "photoVideoToggleClick";
  EventKey["SUCCESS_MODAL_CLOSE_CLICK"] = "successModalCloseClick";
  EventKey["SUCCESS_MODAL_IMPRESSION"] = "successModalImpression";
  EventKey["AUTO_POPULATED_IMPRESSION"] = "autoPopulatedImpression";
  EventKey["NON_AUTO_POPULATED_IMPRESSION"] = "nonAutoPopulatedImpression";
  EventKey["UNAVAILABLE_IMPRESSION"] = "unavailableImpression";
  EventKey["MODAL_UI_EXPERIMENT_EXPOSURE"] = "modalUiExperimentExposure";
  return EventKey;
}({});
var eventMap = (_eventMap = {}, (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_eventMap, EventKey.AUTO_POPULATED_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.autopopulated.impression', EventType.IMPRESSION]
}), EventKey.NON_AUTO_POPULATED_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.non-autopopulated.impression', EventType.IMPRESSION]
}), EventKey.CALENDLY_DATETIME_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.calendly.datetime.click', EventType.CLICK]
}), EventKey.CALENDLY_ERROR_MODAL_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.calendly.error.impression', EventType.IMPRESSION]
}), EventKey.CALENDLY_MODAL_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.calendly.modal.impression', EventType.IMPRESSION]
}), EventKey.CALENDLY_SCHEDULE_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.calendly.schedule.click', EventType.CLICK]
}), EventKey.CAROUSEL_ARROW_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.carousel.arrow.click', EventType.CLICK]
}), EventKey.CAROUSEL_CARD_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.carousel.card.click', EventType.CLICK]
}), EventKey.CAROUSEL_IMAGE_ENLARGE_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.carousel.image.enlarge.click', EventType.CLICK]
}), EventKey.CAROUSEL_SERVICE_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.carousel.service.impression', EventType.IMPRESSION]
}), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_eventMap, EventKey.EXPANDED_IMAGE_VIEW_CLOSE_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.expandedimage.close.click', EventType.CLICK]
}), EventKey.EXPANDED_IMAGE_VIEW_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.expandedimage.impression', EventType.IMPRESSION]
}), EventKey.LOAD_MODAL_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.load.impression', EventType.IMPRESSION]
}), EventKey.LOADER_ERROR_MODAL_CLOSE_CLICK, {
  traffic2: ['usi.dify.leadgenloader.errormodal.close.click', EventType.CLICK]
}), EventKey.LOADER_ERROR_MODAL_IMPRESSION, {
  traffic2: ['usi.dify.leadgenloader.errormodal.impression', EventType.IMPRESSION]
}), EventKey.LOADER_ERROR_MODAL_REFRESH_CLICK, {
  traffic2: ['usi.dify.leadgenloader.errormodal.refresh.click', EventType.CLICK]
}), EventKey.LOADER_LOADING_MODAL_IMPRESSION, {
  traffic2: ['usi.dify.leadgenloader.loadingmodal.impression', EventType.IMPRESSION]
}), EventKey.LOAD_EMBED_IMPRESSION, {
  traffic2: ['usi.dify.leadgenembed.load.impression', EventType.IMPRESSION]
}), EventKey.LEAD_GEN_MODAL_CLOSE_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.form.close.click', EventType.CLICK]
}), EventKey.FORM_SUBMIT_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.form.submit.click', EventType.CLICK]
}), (0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)((0, _defineProperty2.default)(_eventMap, EventKey.PRODUCT_INTENT_DROPDOWN_CHANGE_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.productintent.dropdown.change.click', EventType.CLICK]
}), EventKey.PRODUCT_INTENT_DROPDOWN_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.productintent.dropdown.impression', EventType.IMPRESSION]
}), EventKey.SCHEDULE_BUTTON_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.schedule.button.click', EventType.CLICK]
}), EventKey.SCHEDULE_BUTTON_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.schedule.button.impression', EventType.IMPRESSION]
}), EventKey.SMS_CHECKBOX_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.sms.checkbox.impression', EventType.IMPRESSION]
}), EventKey.PHOTO_VIDEO_TOGGLE_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.photovideo.toggle.impression', EventType.IMPRESSION]
}), EventKey.PHOTO_VIDEO_TOGGLE_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.photovideo.toggle.click', EventType.CLICK]
}), EventKey.SUCCESS_MODAL_CLOSE_CLICK, {
  traffic2: ['usi.dify.leadgenmodal.success.close.click', EventType.CLICK]
}), EventKey.SUCCESS_MODAL_IMPRESSION, {
  traffic2: ['usi.dify.leadgenmodal.success.impression', EventType.IMPRESSION]
}), EventKey.UNAVAILABLE_IMPRESSION, {
  traffic2: ['usi.dify.unavailable.impression', EventType.IMPRESSION]
}), (0, _defineProperty2.default)(_eventMap, EventKey.MODAL_UI_EXPERIMENT_EXPOSURE, {
  traffic2: ['usi.dify.leadgenmodal.modaluiexperiment.exposure', EventType.IMPRESSION]
}));
var _default = exports.default = eventMap;